<nav class="navbar navbar-expand-lg navbar-light p-0">
  <div class="container p-0 d-flex align-items-end">
    <a class="navbar-brand p-0" routerLink="/">
      <img src="../assets/logo.jpg" width="150px" alt="" />
    </a>

    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div
      class="collapse navbar-collapse justify-content-end"
      id="navbarSupportedContent"
    >
      <div
        class="d-block align-items-stretch d-md-flex flex-column align-items-lg-end mt-4 mt-lg-0"
      >
        <!--aqui -->
        <app-pesquisa></app-pesquisa>

        <ul class="navbar-nav mb-2 mb-lg-0 mt-3">
          <li class="nav-item dropdown">
            <a
              class="nav-link active dropdown-toggle"
              id="navbarDropdown"
              aria-current="page"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              >EDUCAÇÃO FINANCEIRA</a
            >
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li class="dropdown-item">
                <a routerLink="/educacao-financeira/o-que-e"
                  >O que é a Educação Financeira</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/educacao-financeira/importancia"
                  >Importância da Educação Financeira
                </a>
              </li>
              <li class="dropdown-item">
                <a
                  routerLink="/educacao-financeira/iniciativa-educacao-financeira"
                  >Iniciativas de Educação Financeira</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/educacao-financeira/perguntas-frequentes"
                  >Perguntas Frequentes</a
                >
              </li>
              <!--li class="dropdown-item"><a routerLink="/educacao-financeira/jogos">Jogos</a></li-->
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              aria-current="page"
              role="button"
              >INCLUSÃO FINANCEIRA</a
            >
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li class="dropdown-item">
                <a routerLink="/inclusao-financeira/o-que-e"
                  >O que é a Inclusão Financeira</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/inclusao-financeira/importancia"
                  >Importância da Inclusão Financeira</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/inclusao-financeira/iniciativas"
                  >Iniciativas de Inclusão Financeira</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/inclusao-financeira/estrategia-nacional"
                  >Estratégia Nacional de Inclusão Financeira (ENIF)</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/inclusao-financeira/observatorio"
                  >Observatório de Inclusão Financeira (OIF)</a
                >
              </li>
              <!--li class="dropdown-item"><a routerLink="/inclusao-financeira/financeira">Financeira (ENIF)</a></li-->
              <!--li class="dropdown-item"><a routerLink="/inclusao-financeira/inqueritos">Inquéritos</a></li>
              <li class="dropdown-item"><a routerLink="/inclusao-financeira/relatorios">Relatórios</a></li-->
            </ul>
          </li>
          <!--li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" id="navbarDropdown" aria-current="page" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">RELACIONAMENTO COM O SISTEMA FINANCEIRO</a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/o-que-e">O que é o Sistema Financeiro</a>
              </li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/composicao-sfa">Composição do Sistema Financeiro Angolano</a>
              </li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/missão-funcoes">BNA, CMC e ARSEG</a>
              </li>

              <--li class="dropdown-item"><a routerLink="/sistemas-financeiros/o-que-e">Contas Bancárias</a> </li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/o-que-e">Depósitos</a> </li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/o-que-e">Crédito</a> </li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/o-que-e">Poupança</a> </li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/o-que-e">Cartões de Débito e de Crédito</a> </li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/o-que-e">Transferências</a> </li>



              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/instituicoes-financeiras">Instituições
                  Financeiras, Funções e
                  Responsabilidades</a></li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/relacionamento-sistema">Relacionamento com
                  o Sistema Financeiro</a></li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/contas-bancarias">Contas Bancárias (o que
                  é, tipos e procedimentos)</a>
              </li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/">Produtos e Serviços Financeiros</a></li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/depositos">Depósitos</a></li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/creditos">Crédito</a></li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/poupanca">Poupança</a></li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/cartoes">Cartões de Débito e Crédito</a>
              </li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/transferencias">Transferências</a></li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/encerramento-contas">Encerramento de
                  conta</a></li>
              <li class="dropdown-item"><a routerLink="/sistemas-financeiros/">Legislação Relevante</a></li->
            </ul>
          </li-->
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              id="navbarDropdown"
              aria-current="page"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              >GESTÃO DE FINANÇAS</a
            >

            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li class="dropdown-item">
                <a routerLink="/gestao-de-financas/financas-pessoais"
                  >Gestão de Finanças Pessoais</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/gestao-de-financas/orcamento-pessoal-familiar">
                  Orçamento Pessoal e Familiar</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/gestao-de-financas/poupanca-investimento"
                  >Poupança e Investimentos</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/gestao-de-financas/credito-e-endividamento"
                  >Crédito e Endividamento</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/gestao-de-financas/medidas-prevencao-protecao"
                  >Medidas de Prevenção e Protecção</a
                >
              </li>
              <!--li class="dropdown-item"><a routerLink="/gestao-de-financas/perguntas-frequentes">Perguntas
                  Frequentes</a></li-->
              <!--li class="dropdown-item"><a routerLink="/gestao-de-financas/comparar-comissoes">Comparador de Comissões
                </a></li-->
            </ul>
          </li>
          <!--li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" id="navbarDropdown" aria-current="page" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">EVENTOS</a>

            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li class="dropdown-item"><a routerLink="/noticias-e-eventos/educacao-financeira">Educação Financeira</a>
              </li>
            </ul>
          </li-->
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              id="navbarDropdown"
              aria-current="page"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              >MATERIAL DE APOIO</a
            >
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li class="dropdown-item">
                <a routerLink="/material-de-apoio/folhetos">Folhetos</a>
              </li>
              <!--li class="dropdown-item"><a routerLink="/material-de-apoio/cadernos">Cadernos de Educação Financeira</a>
              </li-->
              <!--li class="dropdown-item"><a routerLink="/material-de-apoio/apresentacoes">Apresentações</a></li-->
              <li class="dropdown-item">
                <a routerLink="/material-de-apoio/relatorios"
                  >Relatórios e Estatísticas</a
                >
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              id="navbarDropdown"
              aria-current="page"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              >RECLAMAÇÕES</a
            >
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li class="dropdown-item">
                <a routerLink="/reclamacoes/o-que-e">O que é uma Reclamação</a>
              </li>
              <li class="dropdown-item">
                <a routerLink="/reclamacoes/como-fazer"
                  >Como fazer uma Reclamação</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/reclamacoes/onde-fazer"
                  >Onde fazer uma Reclamação</a
                >
              </li>
              <!--li class="dropdown-item">
                <a routerLink="/reclamacoes/reclamar">ção</a>
              </li-->
              <!--li class="dropdown-item"><a routerLink="/reclamacoes/consultar">Consultar Reclamação</a></li-->
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              id="navbarDropdown"
              aria-current="page"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              >DIREITOS DO CONSUMIDOR</a
            >
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li class="dropdown-item">
                <a routerLink="/direitos-do-consumidor/gestao-conta"
                  >Abertura, Movimentação e Encerramento de Contas Bancárias</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/direitos-do-consumidor/produtos-complexos"
                  >Produtos Complexos</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/direitos-do-consumidor/credito-geral"
                  >Crédito Geral</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/direitos-do-consumidor/informacao-contratual"
                  >Informação Contratual</a
                >
              </li>
              <!--li class="dropdown-item"><a routerLink="/direitos-do-consumidor/direitos-deveres">Direitos e deveres</a></li-->
              <li class="dropdown-item">
                <a
                  routerLink="/direitos-do-consumidor/direitos-consulta-precarios"
                  >Direito à Consulta de Preçários</a
                >
              </li>

              <li class="dropdown-item">
                <a routerLink="/direitos-do-consumidor/direito-a-publicidade"
                  >Publicidade de Produtos e Serviços Financeiros</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/direitos-do-consumidor/direito-a-reclamar"
                  >Direito a Reclamar</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/direitos-do-consumidor/direito-a-informacao"
                  >Direito à Informação</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/direitos-do-consumidor/credito-habitacao"
                  >Crédito à Habitação</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/direitos-do-consumidor/sigilo-bancario"
                  >Sigilo Bancário</a
                >
              </li>
              <li class="dropdown-item">
                <a routerLink="/direitos-do-consumidor/protecção-dados"
                  >Protecção de Dados</a
                >
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              id="navbarDropdown"
              aria-current="page"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              >SEGURANÇA E PREVENÇÃO DE FRAUDE</a
            >
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li class="dropdown-item">
                <a
                  routerLink="/seguranca-e-prevencao-de-fraude/conselhos-uteis-utilizacao-cartoes"
                  >Conselhos Úteis na Utilização de Cartões</a
                >
              </li>
              <li class="dropdown-item">
                <a
                  routerLink="/seguranca-e-prevencao-de-fraude/boas-praticas-utilizacao-cheques"
                  >Boas Práticas na Utilização de Cheques</a
                >
              </li>
              <li class="dropdown-item">
                <a
                  routerLink="/seguranca-e-prevencao-de-fraude/boas-praticas-execucao-operacoes-transferencias"
                  >Boas Praticas na Execução de Operações de Transferências</a
                >
              </li>
              <li class="dropdown-item">
                <a
                  routerLink="/seguranca-e-prevencao-de-fraude/boas-praticas-utilizacao-transferencia"
                  >Boas Práticas na Utilização de Transferências Bancárias</a
                >
              </li>

              <li class="dropdown-item">
                <a
                  routerLink="/seguranca-e-prevencao-de-fraude/boas-praticas-utilizacao-internet-banking"
                  >Boas Praticas na Utilização de Internet Banking</a
                >
              </li>
              <li class="dropdown-item">
                <a
                  routerLink="/seguranca-e-prevencao-de-fraude/perguntas-respostas"
                  >Perguntas e Respostas</a
                >
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              id="navbarDropdown"
              aria-current="page"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              routerLink="/portal"
              >FALE CONNOSCO</a
            >
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li class="dropdown-item">
                <a routerLink="/contactos">Contactos</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
